<template>
  <div>
    <custom-actions>
      <template #header>

        <el-button type="primary" v-if="hasAdd" @click="$router.push('/eventRecord/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="title" label="标题">
          <el-input clearable v-model="searchForm.title" placeholder="请输入标题" />

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="标题" prop="title"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="记录内容" prop="content">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="记录人" prop="createUserName">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="记录时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="220">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/eventRecord/detail?eventId=' + row.eventId)">详情</el-button>
            <el-button type="text" v-if="hasAddRecord" @click="$router.push('/eventRecord/addRecord?eventId=' + row.eventId)">新增记录</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/eventRecord/edit?eventId=' + row.eventId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.eventId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'eventRecord',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        title: null
      }

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasAddRecord() {
      return this.buttonList.includes('addRecord')
    }
  },

  created() {
    this.loadData()
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.eventRecord.selectYgnEventByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1

      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        title: null
      }
      this.onSearch()
    },
    deleteRow(eventId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.eventRecord.deleteYgnEvent, {
          eventId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
